module.exports = __webpack_public_path__ + "src/assets/textures/env/small_ladder/small_ladder_hinge_256_bake.png";